import { cn } from '@/helpers/common';

const MainErrorJC = () => (
  <div className="error-page-jc relative w-full overflow-hidden bg-jc-firefly">
    <div className="pointer-events-none absolute inset-0 background-lines" />
    <div className="relative flex flex-col items-center justify-center max-md:my-10 md:my-28 px-4">
      <div className="text-jc-my-sin max-md:text-[44px] md:text-[64px] font-semibold">
        Error 500
      </div>
      <h1 className="text-white mt-6 font-semibold text-xl text-center">Down for Maintenance</h1>
      <div className="text-jc-botticelli mt-2 text-center">
        We&apos;re upgrading our site to serve you better. Thanks for your understanding!
      </div>
      <a
        className={cn(
          'h-12.5 mt-7 default-transition second-font tracking-wider',
          'text-jc-firefly rounded-md px-5 py-3 bg-jc-my-sin font-semibold text-center hover:bg-jc-tangerine',
        )}
        href={'/'}
      >
        HOME
      </a>
    </div>
  </div>
);

export default MainErrorJC;
